// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"b402a05a","213":"3a9b8e91","239":"de6cb1da","328":"0c514e8a","334":"03b474f2","338":"c98382b2","455":"54aafe10","501":"d691f996","557":"e6347eb2","669":"1138085f"}[chunkId] + ".chunk.js";
};